/** Convert a 2-letter country code to its flag emoji. */
export function countryFlag(code?: string): string {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(
    ...code.toUpperCase().split('').map(c => 0x1F1E6 + c.charCodeAt(0) - 65)
  );
}

/** Legal status → badge color classes. */
export function statusColor(status?: string | null | any): string {
  const s = typeof status === 'string' ? status.toLowerCase() : '';
  if (s === 'legal' || s.includes('legal purchase')) return 'bg-green-500/20 text-green-300 border-green-500/30';
  if (s.includes('medical')) return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
  if (s.includes('tolerated')) return 'bg-amber-500/20 text-amber-300 border-amber-500/30';
  if (s.includes('decriminalized')) return 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30';
  if (s.includes('illegal')) return 'bg-red-500/20 text-red-300 border-red-500/30';
  return 'bg-white/10 text-white/60 border-white/20';
}
